// Meta cadastrada pelo cliente (overview_metrics.*_target e metrics.target).
// O pipeline grava 0 quando a empresa não tem linha na tabela targets — e
// hoje nenhuma tem —, então 0 significa "sem meta", não uma meta de 0.
// Devolve null nesse caso para a tela mostrar "-" e não desenhar linha de
// meta nem calcular gap contra 0.
export function metaDefinida(valor) {
  if (valor === null || valor === undefined || valor === "") return null;
  const n = Number(valor);
  return Number.isFinite(n) && n > 0 ? n : null;
}

export function formatMeta(valor, sufixo = "") {
  const meta = metaDefinida(valor);
  return meta === null ? "-" : `${meta}${sufixo}`;
}
